var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mainSection"},[_c('div',{staticClass:"container"},[(this.localStorage.mobile)?_c('Interface',{key:this.localStorage.mobile.last_update,attrs:{"buttons":_vm.buttons}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }